// extracted by mini-css-extract-plugin
module.exports = {"selected":"linkMark_selected__pgUfO","notSelected":"linkMark_notSelected__1AdmO","container":"linkMark_container__1jF7u"};